import { render, staticRenderFns } from "./ConfettiContainer.vue?vue&type=template&id=48c9fca0&scoped=true"
import script from "./ConfettiContainer.vue?vue&type=script&lang=js"
export * from "./ConfettiContainer.vue?vue&type=script&lang=js"
import style0 from "./ConfettiContainer.vue?vue&type=style&index=0&id=48c9fca0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c9fca0",
  null
  
)

export default component.exports